import { BlameLogRefType, BlameLogType, } from '@debbie/common/dist/blamelog/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { blameLogs } from '@debbie/cortex/dist/api/index.js';
import * as tenantsApi from '@debbie/cortex/dist/api/tenants.js';
import q from '@debbie/cortex/dist/query.js';
import { tenantsEntity } from '@debbie/cortex/dist/tenant/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../Button.js';
import Input from '../Input.js';
const AKSSettings = (props) => {
    const lang = useSelector((s) => s.lang);
    const [aksKeyState, setAksKeyState] = useState(props.tenant.aksSettings.key);
    const [hideAKSStats, setHideAKSStats] = useState(true);
    const [aksCodeState, setAksCodeState] = useState(props.tenant.aksSettings.code);
    const [aksUsernameState, setAksUsernameState] = useState(props.tenant.aksSettings.username);
    const [aksPasswordState, setAksPasswordState] = useState(props.tenant.aksSettings.password);
    const save = () => {
        tenantsApi.update(props.tenant.id, {
            aksSettings: {
                ...props.tenant.aksSettings,
                key: aksKeyState,
                code: aksCodeState,
                username: aksUsernameState,
                password: aksPasswordState,
            },
        });
        q.invalidate(keys.write.modify(tenantsEntity, props.tenant.id));
        const changedAksSettings = {
            keyChanged: false,
            codeChanged: false,
            usernameChanged: false,
            passwordChanged: false,
        };
        props.tenant.aksSettings.key !== aksKeyState &&
            (changedAksSettings.keyChanged = true);
        props.tenant.aksSettings.code !== aksCodeState &&
            (changedAksSettings.codeChanged = true);
        props.tenant.aksSettings.username !== aksUsernameState &&
            (changedAksSettings.usernameChanged = true);
        props.tenant.aksSettings.password !== aksPasswordState &&
            (changedAksSettings.passwordChanged = true);
        const blameLog = {
            details: changedAksSettings,
            refId: props.tenant.id,
            refType: BlameLogRefType.TenantSettings,
            type: BlameLogType.AKSConfiguration,
        };
        blameLogs.createBlameLog(blameLog, props.tenant.id);
    };
    return (React.createElement("div", null,
        React.createElement(Input, { placeholder: lang.tenants.AKSKey, value: aksKeyState, onChange: (e) => setAksKeyState(e.target.value) }),
        React.createElement(Input, { placeholder: lang.tenants.AKSCode, value: aksCodeState, onChange: (e) => setAksCodeState(e.target.value) }),
        React.createElement(Input, { placeholder: lang.tenants.AKSUsername, value: aksUsernameState, onChange: (e) => setAksUsernameState(e.target.value) }),
        React.createElement(Input, { placeholder: lang.tenants.AKSPassword, value: aksPasswordState, onChange: (e) => setAksPasswordState(e.target.value), sensitive: true }),
        React.createElement(Button, { onClick: save }, lang.misc.save)));
};
export default AKSSettings;
//# sourceMappingURL=AKSSettings.js.map